export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11zm-10 5a1 1 0 11-2 0 1 1 0 012 0zm-3-7c0-.537.18-1.041.497-1.398C10.798 8.263 11.271 8 12 8c.729 0 1.202.263 1.503.602.317.357.497.861.497 1.398 0 .512-.25.748-1.032 1.239l-.12.074C12.178 11.727 11 12.456 11 14a1 1 0 102 0c0-.36.168-.525 1.032-1.068l.026-.016C14.78 12.462 16 11.696 16 10c0-.963-.32-1.959-1.003-2.727C14.298 6.487 13.271 6 12 6s-2.298.487-2.997 1.273C8.32 8.041 8 9.037 8 10a1 1 0 102 0z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};